import { Component, h, Method, Prop } from "@stencil/core";
import { SortedTableDataRowType, TableDataColumnType } from "../interface";
import { TableDataCell } from "../table-data-cell/table-data-cell";
import { TableDataHeader } from "../table-data-header/table-data-header";

@Component({
    tag: "ux-table-data-column-selection",
    styleUrl: "table-data-column-selection.scss",
    shadow: false
})
export class TableDataColumnSelection implements TableDataColumnType {
    /**
     * Defines if the column should be a group.
     */
    @Prop() readonly group: boolean = false;

    /**
     * Makes the render function public.
     */
    @Method()
    async getColumnMethods() {
        return {
            renderCell: this.renderCell.bind(this),
            renderHeader: this.renderHeader.bind(this)
        };
    }

    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    private renderHeader(tableState: any) {
        const onChange = (event: Event) => {
            const { checked } = event.target as HTMLUxCheckboxElement;
            if (checked) {
                tableState.selectedRows = tableState.sortedData.map((row: SortedTableDataRowType) => row._uxTableInternalId);
            } else {
                tableState.selectedRows = [];
            }
        };
        /*
         *const mixed =
         *    tableState.data &&
         *    tableState.selectedRows &&
         *    tableState.selectedRows.length < tableState.data.length &&
         *    tableState.selectedRows.length !== 0;
         *
         */
        const checked = tableState.data && tableState.selectedRows && tableState.selectedRows.length === tableState.data.length;

        return (
            <TableDataHeader group={this.group}>
                <ux-checkbox
                    onChange={onChange}
                    //mixed={mixed}
                    checked={checked}
                />
            </TableDataHeader>
        );
    }

    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    private renderCell(row: SortedTableDataRowType, tableState: any) {
        const onChange = (event: Event) => {
            const { checked } = event.target as HTMLUxCheckboxElement;

            if (checked) {
                tableState.selectedRows = [...tableState.selectedRows, row._uxTableInternalId];
            } else {
                tableState.selectedRows = tableState.selectedRows.filter((rowId: string) => rowId !== row._uxTableInternalId);
            }
        };

        return (
            <TableDataCell>
                <ux-checkbox onChange={onChange} checked={tableState.selectedRows?.includes(row._uxTableInternalId)} />
            </TableDataCell>
        );
    }
}
